import * as React from 'react';
import { render } from 'react-dom'
import { createHashHistory } from 'history';
import { Provider } from 'react-redux'
import Routes from '../member/routes'

import buildStore from '../member/redux/buildStore'

import environmentVariables from "../shared/enviromentVariables/index.js.erb"
import ErrorView from "../member/components/ErrorView"
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'

const history = createHashHistory()
const store = buildStore({ ...window.__PRELOADED_STATE__ })

const OpenDirector = () => {
    return (
        <Provider store={store}>
            <Routes history={history} />
        </Provider>
    )
}

document.addEventListener('DOMContentLoaded', () => {
    const div = document.createElement('div')
    div.setAttribute('class', 'open-director-frontend')
    const rootElement = document.body.appendChild(div)
    const apiKey = environmentVariables.bugsnag_key || "INVALID-API-KEY"
    const releaseState = environmentVariables.release_state
    const userEmail = window.__PRELOADED_STATE__.users.user.email || 'public-user@opendirector.com.au.invalid'


    Bugsnag.start({
        apiKey: apiKey,
        plugins: [new BugsnagPluginReact()],
        release_state: releaseState,
        user: { email: userEmail }
    })

    const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

    render(
        <ErrorBoundary FallbackComponent={ErrorView}>
            <OpenDirector />
        </ErrorBoundary>, rootElement)
})

// hack turbo to stop and only open streamObserver for badges to work
Turbo.navigator.delegate.stop()
Turbo.navigator.delegate.streamObserver.start()
